import { Link } from "react-router-dom";
import type { Work } from "@/types/content";

interface WorkCardProps {
  work: Work;
  delay?: number;
}

export default function WorkCard({ work, delay = 0 }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block cursor-pointer"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={work.cover}
          alt={`${work.title} 作品封面`}
          title={`${work.title} 剧照海报`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/75 via-primary-950/5 to-transparent opacity-90 transition-opacity duration-500 group-hover:opacity-100"></div>

        <span className="absolute left-2.5 top-2.5 rounded-md bg-primary-950/70 px-2 py-1 text-[11px] font-medium text-background-50 backdrop-blur-sm">
          {work.type === "movie" ? "电影" : "电视剧"}
        </span>

        {work.status === "new" && (
          <span className="absolute right-2.5 top-2.5 rounded-md bg-accent-500 px-2 py-1 text-[11px] font-semibold text-primary-950">
            新作
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between gap-2 p-3">
          <div className="min-w-0 translate-y-1 transition-transform duration-300 group-hover:translate-y-0">
            <p className="line-clamp-1 text-[11px] text-background-200">
              {work.genre}
            </p>
            <p className="mt-0.5 line-clamp-1 text-[11px] text-background-300/90">
              {work.runtime}
            </p>
          </div>
          {work.rating > 0 && (
            <span className="flex shrink-0 items-center gap-1 rounded-md bg-background-50/95 px-1.5 py-1 text-[11px] font-semibold text-foreground-900">
              <i className="ri-star-fill text-[10px] text-accent-500"></i>
              {work.rating.toFixed(1)}
            </span>
          )}
        </div>
      </div>

      <h3 className="mt-3 line-clamp-1 text-[15px] font-medium text-foreground-900 transition-colors group-hover:text-accent-700">
        {work.title}
      </h3>
      <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
        <span className="font-label">{work.year}</span>
        <span className="h-1 w-1 rounded-full bg-background-400"></span>
        <span className="line-clamp-1">{work.genre.split(" / ")[0]}</span>
      </div>
    </Link>
  );
}